import { ui } from "@patient-watch/ui";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import type { UsersOrganisationsRolesViewT } from "@/types/database/profiles";

interface Props {
    usersOrganisationsRoles: UsersOrganisationsRolesViewT[];
}

const OrganisationsRolesTable = (props: Props) => {
    const copy = useProfileCopy();

    const roleLabel = (role: string | null | undefined) => {
        switch (role?.toUpperCase()) {
            case "PATIENT":
                return copy.rolePatient;
            case "CLINICIAN":
                return copy.roleClinician;
            case "SECRETARY":
                return copy.roleSecretary;
            case "ADMIN":
                return copy.roleAdmin;
            case "MANAGER":
                return copy.roleManager;
            case "VALIDATOR":
                return copy.roleValidator;
            case "AUDITOR":
                return copy.roleAuditor;
            default:
                return role ?? "";
        }
    };

    if (!props.usersOrganisationsRoles.length)
        return (
            <div>
                <p className="text-amber-600 text-lg">{copy.informationMissing}</p>
                <p className="text-md text-slate-600">{copy.organisationMissingDescription}</p>
            </div>
        );

    return (
        <ui.Table className="text-lg">
            <ui.TableHeader className="text-slate-700 dark:text-slate-300">
                <ui.TableRow>
                    <ui.TableHead className="pl-0 font-semibold">{copy.organisation}</ui.TableHead>
                    <ui.TableHead className="font-semibold">{copy.role}</ui.TableHead>
                </ui.TableRow>
            </ui.TableHeader>
            <ui.TableBody>
                {props.usersOrganisationsRoles.map((row: UsersOrganisationsRolesViewT) => (
                    <ui.TableRow key={`${row.user_id}_${row.organisation_id}_${row.role}`}>
                        <ui.TableCell className="pl-0 font-medium">{row.organisation_name}</ui.TableCell>
                        <ui.TableCell>{roleLabel(row.role)}</ui.TableCell>
                    </ui.TableRow>
                ))}
            </ui.TableBody>
        </ui.Table>
    );
};

export default OrganisationsRolesTable;
